import { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./Coordenadores.module.css";
import { Link } from "react-router-dom";
import { Button, Form, Modal } from "react-bootstrap";
import { MdDelete, MdEdit, MdSearch, MdClose } from "react-icons/md";
import CoordenadoresApi from "../../services/CoordenadoresApi";
import Paginacao from "../../components/paginacao/Paginacao";
import Alerta from "../../components/alerta/Alerta";
import UsuarioApi from "../../services/UsuarioApi";
import { IoDocumentSharp } from "react-icons/io5";
import Loader from "../../components/loader/Loader";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import InputMask from "react-input-mask";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function Coordenadores() {

    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);

    //Modais para editar e excluir
    const [mostrarModalDeletar, setMostrarModalDeletar] = useState(false);
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false);
    const [coordenadorSelecionado, setcoordenadorSelecionado] = useState(null);

    //Para exibir o alerta
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");

    // paginação com filtro
    const [coordenadores, setCoordenadores] = useState([]);
    const [quantidadeItens, setQuantidadeItens] = useState(0);
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");

    const [nomeFiltro, setNomeFiltro] = useState("");
    const [emailFiltro, setEmailFiltro] = useState("");
    const [paginaAtual, setPaginaAtual] = useState(1); //estado inicial da pagina

    //Para modal de editar
    const [nomeNovo, setNomeNovo] = useState("");
    const [emailNovo, setEmailNovo] = useState("");
    const [nomeContatoNovo, setNomeContatoNovo] = useState("");
    const [cpfNovo, setCpfNovo] = useState(null)
    const [rgNovo, setRgNovo] = useState(null)
    const [statusNovo, setStatusNovo] = useState(null)
    const [dataDeNascimentoNovo, setDataDeNascimentoNovo] = useState(null);
    const [coordenadorId, setCoordenadorId] = useState(null);
    const [statusUsuarios, setStatusUsuarios] = useState([]);

    const [loading, setLoading] = useState(false);

    async function CarregarCoordenadores(paginaAtual, nome, email) {
        try {
            const ListarCoordenadores = await CoordenadoresApi.ListarCoordenadoresComPaginacaoAsync(
                paginaAtual, 
                nome, 
                email);


            setQuantidadeItens(ListarCoordenadores.quantidadeRegistros)
            setCoordenadores(ListarCoordenadores.registros)
        } catch (error) {
            console.error("Erro ao carregar usuários:", error.response.data);
        }


    }

    //Função para abrir o modal de editar
    const AbrirModalEditar = async (coordenador) => {
        const coordenadorEditar = await CoordenadoresApi.ObterCoordenadoresPorIdAsync(coordenador.pessoaID);

        setcoordenadorSelecionado(coordenador);
        setNomeNovo(coordenadorEditar.nomeCompleto);
        setNomeContatoNovo(coordenadorEditar.nomeContato);
        setCpfNovo(coordenadorEditar.cpf);
        setRgNovo(coordenadorEditar.rg);
        setStatusNovo(coordenador.status);
        setCoordenadorId(coordenador.pessoaID);
        setDataDeNascimentoNovo(coordenadorEditar.dataDeNascimento);
        setEmailNovo(coordenadorEditar.email);
        setMostrarModalEditar(true);

    };

    //Função para editar Usuarios
    const BotaoEditar = async () => {
        try {
            setLoading(true);
            await CoordenadoresApi.EditarCoordenadorAsync(coordenadorSelecionado.pessoaID, nomeNovo, nomeContatoNovo, cpfNovo, rgNovo, dataDeNascimentoNovo, statusNovo);
            CarregarCoordenadores();
            setMensagemAlerta(`Coordenador atualizado com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta(true);
        } catch (error) {
            setMensagemAlerta(`Erro ao atualizar Coordenador: ${error.response.data}`);
            setTipoAlerta("danger");
            exibirAlerta(true);
        } finally {
            FecharModal();
            setLoading(false);
        }
    };


    //Função para deletar usuarios
    const BotaoDeletar = async () => {
        try {
            setLoading(true);
            await CoordenadoresApi.DeletarCoordenadorAsync(coordenadorSelecionado.pessoaID);
            setCoordenadores(coordenadores.filter((u) => u.pessoaID !== coordenadorSelecionado.pessoaID));
            setMensagemAlerta(`Coordenador deletado com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta(true);
        } catch (error) {
            setMensagemAlerta(`Erro ao deletar o Coordenador: ${error.response.data}`);
            setTipoAlerta("danger");
            exibirAlerta(true);
        } finally {
            FecharModal();
            setLoading(false);
        }
    };

    //Função para o modal de Editar
    async function BuscarStatusUsuarios() {
        try {
            const status = await UsuarioApi.ListarStatusUsuarioAsync();
            setStatusUsuarios(status);
        } catch (error) {
            console.error("Erro ao buscar status do usuário:", error.response.data);
        }
    }
    //Função para filtro de busca
    async function BuscarUsuarios() {
        setNome(nomeFiltro);
        setEmail(emailFiltro);
        setPaginaAtual(1);
        await CarregarCoordenadores(1, nomeFiltro, emailFiltro);
    }
    //Função para resetar  filtro de busca
    async function ResetarLeads() {
        setNome("");
        setEmail("");
        setNomeFiltro("");
        setEmailFiltro("");
        setPaginaAtual(1);
        await CarregarCoordenadores(1, "", "");
    }

    //Função para alterar a página
    async function AlterarPagina(paginaNova) {
        setPaginaAtual(paginaNova);
        await CarregarCoordenadores(paginaNova, nomeFiltro, emailFiltro);
    }

    //Função para exibir o alerta
    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    //Função para abrir o modal de deletar
    const AbrirModalDeletar = (coordenador) => {
        setcoordenadorSelecionado(coordenador);
        setMostrarModalDeletar(true);
    };

    //Função para o fechar modal
    const FecharModal = () => {
        setMostrarModalDeletar(false);
        setMostrarModalEditar(false);
        setcoordenadorSelecionado(null);
    }

    const totalPages = Math.ceil(quantidadeItens / 10); //total de paginas com itens filtrados

    useEffect(() => {
        BuscarStatusUsuarios();
        // CarregarCoordenadores();
    }, []);

    useEffect(() => {
        CarregarCoordenadores(paginaAtual, nome, email);
    }, []);




    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>            <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Alerta
                tipo={tipoAlerta}
                mensagem={mensagemAlerta}
                visivel={mostrarAlerta}
                aoFechar={() => setMostrarAlerta(false)}
            />
            {loading && <Loader />}
            <div className={style.pagina_conteudo}>
                {/* Cabeçalho da pagina */}
                <div className={style.container_cabecalho}>
                    <h4>Coordenadores</h4>

                </div>

                {/* Filtro de pesquisa */}
                <div className={style.container_filtro}>
                    <InputBuscar
                        type="text"
                        id="hidenNome"
                        placeholder="Nome"
                        name="nome"
                        maxLength={30}
                        value={nomeFiltro}
                        onChange={(e) => setNomeFiltro(e.target.value)}
                    />
                    <InputBuscar
                        type="text"
                        id="hidenEmail"
                        placeholder="Email"
                        name="email"
                        maxLength={50}
                        value={emailFiltro}
                        onChange={(e) => setEmailFiltro(e.target.value)}
                    />
                    <div className={style.container_filtro2} >
                        <Button onClick={BuscarUsuarios} id={style.botao_buscar}><MdSearch /> Buscar
                        </Button>
                        <Button onClick={ResetarLeads} id={style.botao_resetar}><MdClose /> Limpar
                        </Button>
                    </div>

                </div>


                {/* Tabela com paginação */}
                <div className={style.container_tabela_paginacao}>
                    <div className={style.tabela_responsiva}>
                        <table className={style.container_tabela}>
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Email</th>
                                    <th>Último login</th>
                                    <th>Status</th>
                                    <th className={style.coluna_acoes}>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {coordenadores.map((coordenador) => (
                                    <tr className={style.tabela_corpo} key={coordenador.coordenadorID}>
                                        <td title={coordenador.nomeCompleto}>{coordenador.nomeCompleto}</td>
                                        <td title={coordenador.email}>{coordenador.email}</td>

                                        <td title={coordenador.dataUltimoLogin}>{new Date(coordenador.dataUltimoLogin).toLocaleDateString('pt-BR', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric'
                                        })}{' '}
                                            {new Date(coordenador.dataUltimoLogin).toLocaleTimeString('pt-BR', {
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            })}
                                        </td>
                                        <td title={statusUsuarios.find(s => s.id === coordenador.status)?.nome}>{statusUsuarios.find(s => s.id === coordenador.status)?.nome}</td>
                                        <td className={style.coluna_acoes}>

                                            <Link
                                                to="/backoffice/documento"
                                                state={coordenador.pessoaID}
                                                className={style.botao_baixar}
                                            >
                                                <IoDocumentSharp
                                                    title="Documento" />
                                            </Link>
                                            <Link
                                                onClick={() => AbrirModalEditar(coordenador)}
                                                className={style.botao_editar}
                                            >
                                                <MdEdit
                                                    title="Editar" />
                                            </Link>
                                            <Link
                                                onClick={() => AbrirModalDeletar(coordenador)}
                                                className={style.botao_deletar}
                                            >
                                                <MdDelete
                                                    title="Deletar" />
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {/* Controle de Paginação */}
                    <Paginacao
                        id={style.configuracao_paginacao}
                        paginaAtual={paginaAtual}
                        totalPages={totalPages}
                        onPageChange={(novaPagina) => AlterarPagina(novaPagina)}
                    />
                </div>
                {/* Modal de confirmação */}
                <Modal show={mostrarModalDeletar} onHide={FecharModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmar</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        Tem certeza que deseja deletar o coordenador{" "}
                        {coordenadorSelecionado?.nomeCompleto}?
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={FecharModal}>
                            Cancelar
                        </Button>
                        <Button variant="danger" onClick={BotaoDeletar}>
                            Deletar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de confirmação */}
                <Modal show={mostrarModalEditar} onHide={FecharModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Editar Coordenador</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form.Group controlId="nome" className="mb-3">
                            <Form.Label>Nome Completo</Form.Label>
                            <InputBuscar
                                maxLength={100}
                                type="text"
                                placeholder="Nome completo"
                                value={nomeNovo}
                                onChange={(e) => setNomeNovo(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group controlId="email" className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <InputBuscar
                                maxLength={100}
                                type="text"
                                placeholder="Nome completo"
                                value={emailNovo}
                                readOnly
                                disabled

                                onChange={(e) => setEmailNovo(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId="rg" className="mb-3">
                            <Form.Label>RG</Form.Label>
                            <InputMask
                                id={style.desabilitar}
                                mask="99.999.999"
                                value={rgNovo}
                                disabled
                            >
                                {(inputProps) => (
                                    <Form.Control
                                        {...inputProps}
                                        type="text"
                                        placeholder="RG"
                                    />
                                )}
                            </InputMask>
                        </Form.Group>

                        <Form.Group controlId="cpf" className="mb-3">
                            <Form.Label>CPF</Form.Label>
                            <InputMask
                                id={style.desabilitar}
                                mask="999.999.999-99"
                                value={cpfNovo}
                                readOnly
                            >
                                {(inputProps) => (
                                    <Form.Control
                                        {...inputProps}
                                        type="text"
                                        placeholder="CPF"
                                    />
                                )}
                            </InputMask>
                        </Form.Group>

                        <Form.Group controlId="dataNascimento" className="mb-3">
                            <Form.Label>Data de Nascimento</Form.Label>
                            <InputBuscar
                                min="1900-01-01"
                                max="2099-12-31"
                                type="date"
                                value={dataDeNascimentoNovo}
                                onChange={(e) => setDataDeNascimentoNovo(e.target.value)}
                            />
                        </Form.Group>



                        <Form.Group controlId="formStatusUsuario" className="mb-3">
                            <Form.Label>Status do Usuário</Form.Label>
                            <Form.Control
                                as="select"
                                name="statusUsuario"
                                value={statusNovo}
                                onChange={(e) => setStatusNovo(e.target.value)}
                                required
                            >
                                {statusUsuarios.map((statusUsuario) => (
                                    <option key={statusUsuario.id} value={statusUsuario.id}>
                                        {statusUsuario.nome}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={FecharModal}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={BotaoEditar}>
                            Atualizar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </Topbar>
        </Sidebar>

    )
}
export default Coordenadores;